/**
 * Typ kalkulacji przyznanej kwoty
 *
 * @export
 * @enum {number}
 */
export enum DecisionCalculationType {
  AMOUNT = 'AMOUNT',
  INVOICE = 'INVOICE',
  HOLD = 'HOLD',
  WITHDRAWAL = 'WITHDRAWAL'
}

/**
 * Teksty do wyświetlenia typu decyzji
 *
 * @export
 * @enum {number}
 */
export enum DecisionCalculationTypeTranslation {
  AMOUNT = 'Wypłata pełnej kwoty decyzji',
  INVOICE = 'Wypłata na podstawie faktur',
  HOLD = 'Okres wstrzymania pomocy',
  WITHDRAWAL = 'Okres cofnięcia pomocy'
}
